
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DetailDialog from '@/components/busi/table/detail.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { getBusinessList, businessDetail } from '@/api/baseinformation'
@Component({
  name: 'busi-manage',
  components: {
    SimpleTable,
    DetailDialog,
    DictSelect
  }
})
export default class BusiManage extends Vue {
  private form = {
    businessName: '',
    businessState: 1
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'businessName',
    label: '业务名称'
  },
  {
    prop: 'memo',
    label: '备注'
  },
  {
    prop: 'businessStateName',
    label: '状态'
  }]

    private pagination: any = {
      currentPage: 1,
      pageSize: 10
    }

    private async onQuery (pagination: any = null) {
      this.loading = !0
      const form = util.trimForm({ ...this.form })
      !pagination && (this.pagination.currentPage = 1)
      await getBusinessList({
        ...form,
        ...pagination || this.pagination
      }).then((res: any) => {
        this.loading = !1
        this.tableData.list = res.object.list
        this.tableData.totalCount = res.object.totalCount
      }).catch((err: any) => {
        console.log('err', err)
        this.loading = !1
      })
    }

    private onReset () {
      this.form = {
        businessName: '',
        businessState: 1
      }
      this.onQuery()
    }

  private currentPage = 1

  private visible = !1

  private detailData = {}

  private async showDetail (row: any) {
    await businessDetail({ id: row.id }).then((res: any) => {
      if (res.code === 10000) {
        this.visible = !0
        this.detailData = {
          businessName: res.object.businessName,
          businessState: res.object.businessStateName,
          memo: res.object.memo
        }
      }
    })
  }

  mounted () {
    this.onQuery()
  }
}
